import { createFileRoute, useNavigate, Link } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { PostForm } from '@/components/forms/PostForm';
import { useCreatePost } from '@/lib/queries/posts';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import { toast } from 'sonner';

export const Route = createFileRoute('/posts/new')({ component: NewPost });

function NewPost() {
  const nav = useNavigate();
  const create = useCreatePost();
  return (
    <>
      <div className="mb-3">
        <Button variant="ghost" size="sm" asChild className="-ml-2 text-muted-foreground">
          <Link to="/content" search={{ tab: 'posts', status: 'all', q: '', days: 30 }}>
            <ChevronLeft /> 글 목록
          </Link>
        </Button>
      </div>
      <PageHeader title="새 글" description="새 글을 작성합니다" />
      <PostForm submitLabel="생성" onSubmit={async v => {
        try { const res = await create.mutateAsync(v); toast.success('생성됨'); nav({ to: '/posts/$slug', params: { slug: res.slug } }); }
        catch (e) { toast.error((e as Error).message); }
      }} />
    </>
  );
}
